import { FormattedMessage } from "react-intl";
import { Label } from "react-bootstrap";
import React from "react";
import { differenceInDays, differenceInMilliseconds } from "../../utils/DateDifferenceUtil";

type PromotionRemainingDaysLabelProps = {
    promotionStart?: string | null | undefined;
    promotionEnd?: string | null | undefined;
};

export function PromotionRemainingDaysLabel({ promotionStart, promotionEnd }: PromotionRemainingDaysLabelProps) {
    let promotionRemainingDaysText = null;
    if (promotionEnd) {
        const end = new Date(promotionEnd);
        if (!isNaN(end.getTime())) {
            const remainingDays = differenceInDays(end, new Date());
            if (remainingDays > 0) {
                promotionRemainingDaysText = (
                    <FormattedMessage
                        className="test-promotion-remaining-days"
                        id={"SD_ARTICLECARD_PROMOTION_REMAINING_DAYS"}
                        values={{
                            days: remainingDays
                        }}
                    />
                );
            } else if (remainingDays === 0 && differenceInMilliseconds(end, new Date()) > 0) {
                promotionRemainingDaysText = (
                    <FormattedMessage
                        className="test-promotion-remaining-days-zero"
                        id={"SD_ARTICLECARD_PROMOTION_REMAINING_DAYS_ZERO"}
                    />
                );
            }
        }
    }
    if (promotionStart) {
        const start = new Date(promotionStart);
        if (!isNaN(start.getTime())) {
            const remainingDaysToStart = differenceInDays(start, new Date());
            if (remainingDaysToStart > 0) {
                promotionRemainingDaysText = (
                    <FormattedMessage
                        className="test-promotion-remaining-days-until-start"
                        id={"SD_ARTICLECARD_PROMOTION_DAYS_UNTIL_START"}
                        values={{
                            days: remainingDaysToStart
                        }}
                    />
                );
            } else if (remainingDaysToStart === 0 && differenceInMilliseconds(start, new Date()) > 0) {
                promotionRemainingDaysText = (
                    <FormattedMessage
                        className="test-promotion-remaining-days-until-start-zero"
                        id={"SD_ARTICLECARD_PROMOTION_DAYS_UNTIL_START_ZERO"}
                    />
                );
            }
        }
    }
    if (promotionRemainingDaysText) {
        return <Label className="label-rectangular label-promotion-remaining-days">{promotionRemainingDaysText}</Label>;
    } else {
        return null;
    }
}
